import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import OldStyleSection from '../../common/oldStyleSection';
import CustomTooltip from "../../common/customTooltip";

import './subjectActivity.scss';

class SubjectActivity extends React.Component {
    render() {
        return (isNullOrUndefined(this.props.data) ? null : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent(data) {
        const { activity, naceList, tradeInfo } = data;
        return (
            <>
                {!isNullOrUndefined(naceList) && naceList.length > 0 && <OldStyleSection isBold hasData
                    name={this.props.translate("Report.NaceList.SectionName")}
                >
                    {this.renderNaceTable(naceList)}
                </OldStyleSection>}
                {!isNullOrUndefined(activity) && activity.activities.length > 0 && <OldStyleSection isBold hasData
                    name={this.props.translate("Report.SubjectActivitySk.SectionName")}
                >
                    {this.renderActivityTable(activity)}
                </OldStyleSection>}
                {!isNullOrUndefined(tradeInfo) && tradeInfo.activities.length > 0 && <OldStyleSection isBold hasData
                    name={this.props.translate("Report.TradingActivities.SectionName")}
                >
                    {this.renderTradeInfoTable(tradeInfo)}
                </OldStyleSection>}
            </>
        );
    }

    renderNaceTable = (data) => {
        const main = data.filter(f => f.mainType);
        const other = data.filter(f => !f.mainType && f.active);

        return (
            <>
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderNaceHead("Report.Nace.Code.Main")} tableColumns={5} stripped
                    actualData={main.filter(f => f.active)} actualRow={(r) => this.renderNaceRow(r, false)}
                    historyData={main.filter(f => !f.active)} historyRow={(r) => this.renderNaceRow(r, true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderNaceHead("Report.Nace.Code.Minor")} tableColumns={3} stripped
                    actualData={other} actualRow={(r) => this.renderNaceRow(r, false)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                <ExcelExportButton link="nace-list" entityId={this.props.id} report={this.props.reportType} />
            </>
        );
    }

    renderActivityTable = (data) => {
        const historical = data.activities.filter(x => x.to !== null);
        const active = data.activities.filter(x => x.to === null);
        return (
            <>
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderHead()} tableColumns={4} stripped
                    actualData={active} actualRow={(r) => this.renderRow(r, "activity")}
                    historyData={historical} historyRow={(r) => this.renderRow(r, "activityHistory", true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                <ExcelExportButton link="subject-activity" entityId={this.props.id} report={this.props.reportType} />
            </>
        );
    }

    renderTradeInfoTable(data) {
        const historical = data.activities.filter(x => x.to !== null);
        const active = data.activities.filter(x => x.to === null);
        return (
            <>
                <OldStyleTableWithHistory
                    offsetLeft={false}
                    head={() => this.renderHead(undefined, true)} tableColumns={5} stripped
                    actualData={active} actualRow={(r) => this.renderRow(r, "tradeInfo", undefined, undefined, true)}
                    historyData={historical} historyRow={(r) => this.renderRow(r, "tradeInfoHistory", true, undefined, true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                <ExcelExportButton link="trade-info" entityId={this.props.id} report={this.props.reportType} />
            </>
        );
    }

    renderHead = (isActivity = true, isTradeInfo = false) => {
        return (
            <thead>
                <tr>
                    <th><Translate id="Report.Common.Title" /></th>
                    <th className="col-3" style={{ textAlign: "right" }}><Translate id="Report.Common.From" /></th>
                    {isActivity && <th className="col-3" style={{ textAlign: "right" }}><Translate id="Report.Common.To" /></th>}
                    {isTradeInfo && <th className="col-3" style={{ textAlign: 'right' }}><Translate id="Report.TradingActivities.TradeInterruption" /></th>}
                    <th className="col-3" style={{ textAlign: 'right' }}><Translate id="Report.Common.Source" /></th>
                </tr>
            </thead>
        );
    }

    renderRow = (a, prefix, isHistory = false, isActivity = true, isTradeInfo = false) => {
        return (
            <tr key={a.rowId} className={classnames("colorize", { "old-style-table-report-history-row": isHistory })}>
                <td style={{ fontWeight: "normal" }} className="always-new-line">{a.activity}</td>
                <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{a.fromFormated}</td>
                {isActivity && <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>{isHistory ? a.toFormated : null}</td>}
                {isTradeInfo && <td style={{ textAlign: 'right' }}>{a.breaks.map((x) => this.renderBreaksColumn(x.breakStartFormated, x.breakEndFormated, x.isActive))}</td>}
                <td style={{ textAlign: 'right' }}>
                    <CustomTooltip textAlign="right" placement='left' id={prefix + a.rowId} text={a.sourceDescription} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                        {a.source}
                    </CustomTooltip>
                </td>
            </tr>
        );
    }

    renderBreaksColumn = (breakStart, breakEnd, active) => {
        let date = "";
        if (isNullOrUndefined(breakEnd) && breakEnd !== "") {
            date = this.props.translate("Report.TradeInterruptions.From") + " " + breakStart;
        } else {
            date += breakStart + " - " + breakEnd;
        }

        if (active) return <span>{date}<br /></span>;

        return <span style={{ color: '#8d949e', fontStyle: 'italic' }}>{date}<br /></span>;
    }

    renderNaceHead = (firstColLabel) => {
        return (
            <thead className="sub-activity-header">
                <tr>
                    <th className="col-1"><Translate id={firstColLabel} /></th>
                    <th><Translate id="Report.Nace.Name" /></th>
                    <th className="col-3" style={{ textAlign: "right" }}><Translate id="Common.From" /></th>
                    <th className="col-4" style={{ textAlign: "right" }}><Translate id="Common.To" /></th>
                    <th className="col-5" style={{ textAlign: "right" }}><Translate id="Report.Nace.Source" /></th>
                </tr>
            </thead>
        );
    }

    renderNaceRow = (n, isHistory) => {
        return (
            <tr key={n.id} className={classnames("colorize", { "old-style-table-report-history-row": isHistory })}>
                <td>{n.code}</td>
                <td>{n.desc}</td>
                <td style={{ textAlign: "right" }}>{n.startDateFormatted}</td>
                <td style={{ textAlign: "right" }}>{isHistory ? n.endDateFormatted : null}</td>
                <td style={{ whiteSpace: "nowrap", textAlign: 'right' }}>
                    <CustomTooltip textAlign="right" placement='left' id={"historyRow" + n.id} text={n.sourceDescription} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                        {n.source}
                    </CustomTooltip>
                </td>
            </tr>
        )
    }
}

export default withLocalize(connect(
    state => state.report, dispatch => bindActionCreators(reportActions, dispatch)
)(SubjectActivity))